var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.08 -0.492)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.08 0.492)",
    fill: "none",
    stroke: "#e52431",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 28,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.33,6.67a7.415,7.415,0,0,0-10.488,0L16.413,8.1,14.984,6.67A7.416,7.416,0,1,0,4.5,17.159l1.429,1.429L16.413,29.076,26.9,18.588l1.429-1.429a7.415,7.415,0,0,0,0-10.488Z",
    transform: "translate(12.757 13.744)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.5d8a43af28203248fc1098e7d44a90ac.svg";
export { ForwardRef as ReactComponent };